export default __webpack_public_path__ + "static/media/appstore.fac8ea20.png";